module.exports = __webpack_public_path__ + "img/zndxxyyy.b25e0496.png";